// Store Context - Converted from Pinia store (stores/store.js)
// Provides global state management using React Context API
import React, { createContext, useContext, useState, ReactNode } from 'react';

// Store state interface
interface StoreState {
  isActive: boolean;
}

// Store actions interface
interface StoreActions {
  toggle: () => void;
}

// Combined store interface
interface Store extends StoreState, StoreActions {}

// Create context
const StoreContext = createContext<Store | undefined>(undefined);

// Store provider component
export const StoreProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isActive, setIsActive] = useState<boolean>(false);

  const toggle = () => {
    setIsActive(prev => !prev);
  };

  const value: Store = {
    isActive,
    toggle,
  };

  return (
    <StoreContext.Provider value={value}>
      {children}
    </StoreContext.Provider>
  );
};

// Custom hook to use the store
export const useMainStore = (): Store => {
  const context = useContext(StoreContext);
  if (context === undefined) {
    throw new Error('useMainStore must be used within a StoreProvider');
  }
  return context;
};
